import React from "react";
import "../home.css";
import logo from "../Image/Logo1.png";
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import InstagramIcon from "@mui/icons-material/Instagram";
import YouTubeIcon from "@mui/icons-material/YouTube";
import { Link } from "react-router-dom";

// const footerLogo = (
//   <img
//     src="https://upload.wikimedia.org/wikipedia/commons/a/a7/React-icon.svg"
//     alt="Logo"
//     className="footer-logo"
//   />
// );

const socialLinks = [
  { icon: <FacebookIcon />, url: "#" },
  { icon: <TwitterIcon />, url: "#" },
  {
    icon: <LinkedInIcon />,
    url: "https://www.linkedin.com/company/acadmetech/",
  },
  {
    icon: <InstagramIcon />,
    url: "https://www.instagram.com/acadme_edtech?igsh=MWJ3cHd4ZzMxcmE1cA==",
  },
  { icon: <YouTubeIcon />, url: "#" },
];

function Footer() {
  return (
    <footer className="footer-container">
      <div className="footer-row">
        <div className="footer-left">
          <Link to="/">
          <img src={logo} alt="Logo" className="footer-logo" />
          </Link>

          <div className="footer-desc">
            Empowering learners with industry-ready skills and real
            opportunities.
          </div>
          <div className="footer-social-row">
            {socialLinks.map((item, index) => (
              <a key={index} href={item.url} className="footer-social-icon">
                {item.icon}
              </a>
            ))}
          </div>
        </div>

        <div>
          <div className="footer-list-title">Company</div>
          <ul className="footer-list">
            {/* <li to="/about-us" className="footer-list-item">About Us</li> */}
            <li className="footer-list-item">
  <Link to="/about-us">About Us</Link>
</li>
  
            <li className="footer-list-item">
              <Link to="/careers">Careers</Link>
              
              </li>
            <li className="footer-list-item">Press</li>
            <li className="footer-list-item">Blog</li>
          </ul>
        </div>

        <div>
          <div className="footer-list-title">Quick Links</div>
          <ul className="footer-list">
            <li className="footer-list-item">
              <Link to="/register">Get Started</Link>
              </li>
            <li className="footer-list-item">Pricing</li>
            <li className="footer-list-item">For Business</li>
            <li className="footer-list-item">Become Mentor</li>
          </ul>
        </div>

        <div>
          <div className="footer-list-title">Courses</div>
          <ul className="footer-list">
            <li className="footer-list-item">
              <Link to="/cyber-security">Cybersecurity</Link>
             </li>
            <li className="footer-list-item">
               <Link to="/web-development">Full Stack Web Dev</Link>
             </li>
            <li className="footer-list-item">
                <Link to="/data-science"> Data Science</Link>
             </li>
            <li className="footer-list-item">
                <Link to="/artificial-intelligence">AI</Link>
              </li>
          </ul>
        </div>

        <div>
          <div className="footer-list-title">Support</div>
          <ul className="footer-list">
                 <li className="footer-list-item">
                   <Link to="/contact-us">Contact Us</Link>
                  </li>
            <li className="footer-list-item">Help Center</li>
            <li className="footer-list-item">Privacy Policy</li>
            <li className="footer-list-item">Terms of Service</li>
          </ul>
        </div>
      </div>
      <div className="footer-bottom-row">
        Acadme EdTech Pvt. Ltd. — Gurgaon, Haryana | © 2025 All rights reserved.
      </div>
    </footer>
  );
}

export default Footer;
